module.exports = __webpack_public_path__ + "static/media/icons.f7c2b4b7.eot";


//////////////////
// WEBPACK FOOTER
// ./src/icons/icons.eot
// module id = 426
// module chunks = 0